/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React, { useEffect, useState } from 'react';
import { TextInput } from '@carbon/react';
import { useTranslation } from 'react-i18next';

const TestToolHobaAuth = ({ hobaCreds, onChange }) => {
  const [hobaKeyIdentifier, setHobaKeyIdentifier] = useState('');
  const [hobaChallenge, setHobaChallenge] = useState('');
  const [hobaNonce, setHobaNonce] = useState('');
  const [hobaSignature, setHobaSignature] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    setHobaKeyIdentifier(hobaCreds.hobaKeyIdentifier ?? '');
    setHobaChallenge(hobaCreds.hobaChallenge ?? '');
    setHobaNonce(hobaCreds.hobaNonce ?? '');
    setHobaSignature(hobaCreds.hobaSignature ?? '');
  }, [hobaCreds.hobaChallenge, hobaCreds.hobaKeyIdentifier, hobaCreds.hobaNonce, hobaCreds.hobaSignature]);

  const handleHttpHobaKeyIdentifierChange = (event) => {
    const hobaKeyIdentifier = event.target.value;
    setHobaKeyIdentifier(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ hobaNonce, hobaSignature, hobaChallenge, hobaKeyIdentifier });
    }
  };

  const handleHttpHobaChallengeChange = (event) => {
    const hobaChallenge = event.target.value;
    setHobaChallenge(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ hobaNonce, hobaSignature, hobaChallenge, hobaKeyIdentifier });
    }
  };

  const handleHttpHobaNonceChange = (event) => {
    const hobaNonce = event.target.value;
    setHobaNonce(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ hobaNonce, hobaSignature, hobaChallenge, hobaKeyIdentifier });
    }
  };

  const handleHttpHobaSignatureChange = (event) => {
    const hobaSignature = event.target.value;
    setHobaSignature(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ hobaNonce, hobaSignature, hobaChallenge, hobaKeyIdentifier });
    }
  };

  return (
    <div className="testToolHobaAuth">
      <div className="hobakeyidentifier">
        <div className="labelText">{t('key_identifier')}</div>
        <TextInput id="hobakeyidentifier" hideLabel labelText={t('key_identifier')} value={hobaKeyIdentifier} onChange={handleHttpHobaKeyIdentifierChange} />
      </div>

      <div className="hobachallenge">
        <div className="labelText">{t('challenge')}</div>
        <TextInput id="hobachallenge" labelText={t('challenge')} hideLabel value={hobaChallenge} onChange={handleHttpHobaChallengeChange} />
      </div>

      <div className="hobanonce">
        <div className="labelText">{t('nonce')}</div>
        <TextInput id="hobanonce" labelText={t('nonce')} hideLabel value={hobaNonce} onChange={handleHttpHobaNonceChange} />
      </div>

      <div className="hobasignature">
        <div className="labelText">{t('signature')}</div>
        <TextInput id="hobasignature" labelText={t('signature')} hideLabel value={hobaSignature} onChange={handleHttpHobaSignatureChange} />
      </div>
    </div>
  );
};

export default TestToolHobaAuth;
